export default "__VITE_ASSET__BOM0OSzK__"